import {
  loadProductSuccess,
  loadProductFail,
  loadProduct,
} from '../actions/product.action';
import { BoelsGenericState, BOProduct } from '@boels/models';
import { createReducer, on } from '@ngrx/store';

interface ProductDictionary {
  [culture: string]: {
    [productId: string]: BOProduct;
  };
}

export interface ProductState extends BoelsGenericState {
  entities?: ProductDictionary;
}

export const productInitialState: ProductState = {
  entities: undefined,
  error: false,
  loading: false,
  success: false,
};

export const reducer = createReducer(
  productInitialState,
  on(loadProduct, (state) => ({
    ...state,
    loading: true,
    success: false,
    error: false,
  })),
  on(loadProductSuccess, (state, action) => ({
    ...state,
    entities: {
      ...state.entities,
      [action['culture']]: {
        ...state.entities?.[action['culture']],
        [action['product'].code as string]: action['product'],
      },
    },
    error: false,
    loading: false,
    success: true,
  })),
  on(loadProductFail, (state, { errorMessage }) => ({
    ...state,
    error: true,
    loading: false,
    success: false,
    errorMessage,
  })),
);
